import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { whyGroups, proofPoints } from "../data/navigation";
import { images } from "../data/images";
import { NoteTag } from "./NoteTag";
type WhyMegaMenuProps = {
  showNotes: boolean;
};
export function WhyMegaMenu({
  showNotes
}: WhyMegaMenuProps) {
  return <div className="bg-i9-blue text-white shadow-[0_24px_48px_-16px_rgba(22,21,74,0.55)]" data-id="element-224" data-mp="hvozq7c91l2j">
      <div className="grid grid-cols-12 gap-10 px-10 pb-8 pt-9" data-id="element-225" data-mp="15jyif0e61spg">
        {/* Feature: mission */}
        <div className="col-span-4" data-id="element-226" data-mp="1ajkwfc1tjczb">
          <div className="relative" data-id="element-227" data-mp="1aijh2vdrs4bs">
            <img src={images.mission} alt="An i9 Sports staff coach huddled with a flag football team" className="aspect-[4/3] w-full object-cover object-[50%_60%]" data-id="element-228" data-mp="vmakk1l9k532" />
            <div className="absolute -bottom-1 left-0 h-2 w-2/3 bg-i9-red" aria-hidden="true" data-id="element-229" data-mp="10n83ige3l35m" />
          </div>
          <p className="mt-6 font-display text-sm font-bold uppercase italic tracking-wider text-i9-sky" data-id="element-230" data-mp="3gem508parwbc">Our Mission</p>
          <p className="mt-1 font-display text-[28px] font-extrabold uppercase leading-[1.05]" data-id="element-231" data-mp="djxd21nejj0g">
            To help kids succeed in life through sports
          </p>
          <a href="#" className="group mt-4 inline-flex items-center gap-2 text-sm font-semibold text-white underline-offset-4 hover:underline" data-id="element-232" data-mp="8n71nrmjlbld">
            Read our story
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-233" data-mp="ho57mfgjjt6l" />
          </a>
        </div>

        {/* Links */}
        <div className="col-span-8 flex flex-col" data-id="element-234" data-mp="rjgmqyvv32ev">
          <div className="grid grid-cols-2 gap-10" data-id="element-235" data-mp="15b4xaxqgpitq">
            {whyGroups.map(group => <div key={group.heading} data-id="element-236" data-mp="11a1jegrz5wv5">
                <h3 className="font-display text-lg font-extrabold uppercase italic tracking-wider" data-id="element-237" data-mp="11b2swgtcebar">{group.heading}</h3>
                <ul className="mt-3" data-id="element-238" data-mp="1f9u49vgtliv7">
                  {group.items.map(item => <li key={item.label} data-id="element-239" data-mp="1ac12demjvb0q">
                      <a href="#" className="group -mx-3 block rounded-sm px-3 py-3 transition-colors duration-150 ease-out hover:bg-white/10 focus-visible:bg-white/10 focus-visible:outline-none" data-id="element-240" data-mp="7x1q4ndfgvjk">
                        <span className="flex items-center justify-between gap-3 text-[17px] font-semibold" data-id="element-241" data-mp="gwf1jll43u6x">
                          <span className="flex items-center gap-2" data-id="element-242" data-mp="lqj9a727c692">
                            {item.label}
                            {showNotes && item.label === "Our Mission" && <NoteTag data-id="element-243" data-mp="vll3hhbc3yii">Was “About i9 Sports”</NoteTag>}
                          </span>
                          <ArrowRightIcon className="h-4 w-4 shrink-0 opacity-0 transition-[opacity,transform] duration-150 ease-out group-hover:translate-x-0.5 group-hover:opacity-100" data-id="element-244" data-mp="zpal1mtldfu1" />
                        </span>
                        <span className="mt-0.5 block text-sm text-white/75" data-id="element-245" data-mp="31h5mzaq1q5z2">{item.description}</span>
                      </a>
                    </li>)}
                </ul>
              </div>)}
          </div>

          <dl className="mt-auto grid grid-cols-3 border-t border-white/20 pt-6" data-id="element-246" data-mp="2u4g0rsrsuw7d">
            {proofPoints.map((p, i) => <div key={p.label} className={i > 0 ? "border-l border-white/20 pl-6" : "pr-6"} data-id="element-247" data-mp="2p4ley3mvswt6" data-mpi={i}>
                <dt className="sr-only" data-id="element-248" data-mp="2k71ng216anja">{p.label}</dt>
                <dd className="font-display text-2xl font-extrabold uppercase italic leading-none text-white" data-id="element-249" data-mp="2k475qi9jngtk">{p.value}</dd>
                <dd className="mt-1.5 text-sm text-white/75" data-id="element-250" data-mp="3cv78yr01wgk6">{p.label}</dd>
              </div>)}
          </dl>
        </div>
      </div>

      {/* Wayfinding to relocated content */}
      <div className="relative bg-i9-ink px-10 py-4" data-id="element-251" data-mp="33u9eazbi5le9">
        <div className="absolute -top-5 left-0 right-0 h-5 bg-i9-ink" style={{
        clipPath: "polygon(55% 100%, 100% 0, 100% 100%)"
      }} aria-hidden="true" data-id="element-252" data-mp="33tpv7fa48qyn" />
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm" data-id="element-253" data-mp="1seb1ckd7ef7r">
          <span className="text-white/70" data-id="element-254" data-mp="3gbihnbiixaxl">Looking for sports, age groups or FAQs?</span>
          <a href="#" className="font-semibold text-white hover:text-i9-sky" data-id="element-255" data-mp="3l30ky680rnlq">Sports & Age Groups → Programs</a>
          <a href="#" className="font-semibold text-white hover:text-i9-sky" data-id="element-256" data-mp="36edvhboohfgs">FAQs → Contact</a>
          {showNotes && <NoteTag data-id="element-257" data-mp="3bdqqijppdsug">Relocated links stay findable</NoteTag>}
        </div>
      </div>
    </div>;
}